const TYPES = Object.freeze({
});

const stateObject = {
  isOpen: false
};

const getters = {
  isOpen: state => {
    return state.isOpen;
  },
};

const mutations = {
  SHOW(state) {
    state.isOpen = true
  },
  HIDE(state) {
    state.isOpen = false
  },
  TOGGLE(state) {
    state.isOpen = !state.isOpen
  },
};

const actions = {
};

export default {
  namespaced: true,
  state: stateObject,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/menu.js